import __request__ from "routing/request";
export function widgetSummaryAvailability(widgetType, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.assistant/assistant/widget-summary/${widgetType}/availability`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
